import script from "./IttenkoTimesForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./IttenkoTimesForm.vue?vue&type=script&setup=true&lang=ts"

import "./IttenkoTimesForm.vue?vue&type=style&index=0&id=7132ab88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7132ab88"]])

export default __exports__